
import * as sshConst from './constants';

export default {
    [sshConst.describeKeys](state, data) {
        state.list = data.KeySet;
        state.total = data.TotalCount;
    }
};
